import React from 'react';
import { SocialIcon } from 'react-social-icons';

interface SocialLinksProps {
  className?: string;
  iconSize?: 'sm' | 'md' | 'lg';
  darkMode?: boolean;
}

const SocialLinks: React.FC<SocialLinksProps> = ({
  className = '',
  iconSize = 'md',
  darkMode = false
}) => {
  const socialLinks = [
    { url: 'https://twitter.com/ACrewTransport' },
    { url: 'https://www.linkedin.com/in/troymak' },
    { url: 'https://www.facebook.com/airlinecrewtrans' },
    { url: 'https://www.instagram.com/airlinecrewtrans/' },
    { url: 'https://twitter.com/mediaairlinecr1' },
    { url: 'https://www.tiktok.com/@airlinecrewtrans' },
  ];

  // Convert size names to pixel values
  const sizeMap = {
    sm: 32,
    md: 40,
    lg: 48
  };

  const size = sizeMap[iconSize];

  // Style colors based on dark mode
  const bgColor = darkMode ? '#ffffff1a' : '#00000010';
  const fgColor = darkMode ? '#ffffff' : '#000000';

  return (
    <ul className={`social-links social-links--${iconSize} ${className}`} style={{
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: 0,
      margin: 0,
      gap: '12px',
      justifyContent: 'center',
      maxWidth: '240px' // This will ensure 3 icons per row on mobile (48px icon + 12px gap)
    }}>
      {socialLinks.map((link, index) => (
        <li key={index} className="social-links__item" style={{
          margin: 0 // Remove default margin since we're using gap
        }}>
          <SocialIcon
            url={link.url}
            style={{ height: size, width: size }}
            bgColor={bgColor}
            fgColor={fgColor}
            target="_blank"
          />
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks; 